module.exports = __webpack_public_path__ + "static/img/partner5.fca81f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner5.png
// module id = Se1t
// module chunks = 202